import Vue from "vue";
import Vuex from "vuex";
import contactDetail from "./modules/contactDetail";
import registration from "./modules/registration";
import personalInfo from "./modules/personalInfo";
import resetPassword from "./modules/resetPassword";
import customer from "./customer.module";
import receiver from "./receiver.module";
import transaction from "./transaction.module";
import accounts from "./accounts.module";
import partner from "./partner.module";
import auth from "./auth.module";
import business from "./business.module";
import internalUser from "./modules/internalUser";
import rolemenu from "./rolemenu.module";
import bin from "./bin.module";
import ipblocklist from "./ipblocklist.module";
import authpermission from "./modules/authpermission";
import notification from "./notification.module";
import onboarding from "./onboarding.module";
import config from "./config.module";
import offers from "./offers.module";
import holds from "./holds.module";
import reroute from "./reroute.module";
import namecheck from "./namecheck.module";
import statement from "./statement.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    contactDetail,
    registration,
    personalInfo,
    resetPassword,
    customer,
    receiver,
    transaction,
    accounts,
    partner,
    auth,
    business,
    internalUser,
    rolemenu,
    bin,
    ipblocklist,
    authpermission,
    notification,
    onboarding,
    config,
    offers,
    holds,
    reroute,
    namecheck,
    statement
  },
  // strict: debug,
  // plugins: debug ? [createLogger()] : []
});
